import { jsx as x } from "react/jsx-runtime";
import { c as b } from "../../vendor-B6xhktLJ.js";
import { forwardRef as h, useState as v, useEffect as S } from "react";
import { getSpacingClasses as C } from "../../utils/getSpacingClasses/index.js";
import { omit as y } from "../../utils/omit/index.js";
import { loadIcon as N } from "./loadIcon/index.js";
import '../../assets/index7.css';const j = "IAzkAq_baseIcon", w = "IAzkAq_blue", B = "IAzkAq_cactus", E = "IAzkAq_color", H = "IAzkAq_gold", L = "IAzkAq_green", M = "IAzkAq_lg", R = "IAzkAq_magenta", T = "IAzkAq_md", D = "IAzkAq_moon", F = "IAzkAq_purple", G = "IAzkAq_red", J = "IAzkAq_sienna", K = "IAzkAq_sm", O = "IAzkAq_teal", P = "IAzkAq_xl", Q = "IAzkAq_xs", o = {
  baseIcon: j,
  blue: w,
  cactus: B,
  color: E,
  gold: H,
  green: L,
  lg: M,
  magenta: R,
  md: T,
  moon: D,
  purple: F,
  red: G,
  sienna: J,
  sm: K,
  teal: O,
  xl: P,
  xs: Q
}, $ = h(
  ({
    m: n,
    mt: a,
    mr: c,
    mb: r,
    ml: l,
    p: A,
    pt: m,
    pr: I,
    pb: _,
    pl: g,
    icon: s,
    description: e,
    color: t,
    size: u = "md",
    className: d,
    ...k
  }, q) => {
    const [z, i] = v(""), p = b(
      {
        [o.baseIcon]: !0,
        [o[u]]: !0,
        ...t ? { [o[t]]: !0, [o.color]: !0 } : void 0,
        ...C({ m: n, mt: a, mr: c, mb: r, ml: l, p: A, pt: m, pr: I, pb: _, pl: g })
      },
      d
    );
    return S(() => {
      N(s).then((f = "") => i(f));
    }, [s]), /* @__PURE__ */ x(
      "span",
      {
        ...y(k, ["className", "style", "slot", "children"]),
        ref: q,
        "data-icon-name": s,
        className: p,
        role: e ? "img" : "presentation",
        "aria-label": e,
        "aria-hidden": e ? void 0 : "true",
        dangerouslySetInnerHTML: { __html: z }
      }
    );
  }
);
export {
  $ as BaseIcon
};
//# sourceMappingURL=index.js.map
